export const tableConfig = [
  {
    name: "mechanicName",
    label: "Tim Mekanik",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "200px", minWidth: "200px", textAlign: "center" },
      }),
    },
  },
  {
    name: "q1y2",
    label: "Q1 Y-2",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "q2y2",
    label: "Q2 Y-2",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "q3y2",
    label: "Q3 Y-2",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "q4y2",
    label: "Q4 Y-2",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "q1y1",
    label: "Q1 Y-1",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "q2y1",
    label: "Q2 Y-1",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "q3y1",
    label: "Q3 Y-1",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "q4y1",
    label: "Q4 Y-1",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "q1y",
    label: "Q1 Y",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "q2y",
    label: "Q2 Y",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "q3y",
    label: "Q3 Y",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "q4y",
    label: "Q4 Y",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
];

export function transformChartData(input) {
  if (!input?.length) {
    return { data: [], dataKey: [] };
  }

  const quarterKeys = Object.keys(input[0]).filter(
    key => key !== "name" && key !== "no"
  );

  if (!quarterKeys.length) {
    return { data: [], dataKey: [] };
  }

  const employeeNames = input
    .map(entry => entry.mechanicName)
    .filter(name => name !== "TOTAL");


  const chartData = quarterKeys.map(quarter => {
    const row = { division: quarter };
    input.forEach(entry => {
      if (entry.mechanicName !== "TOTAL") {
        row[entry.mechanicName] = entry[quarter];
      }
    });
    return row;
  });

  // Buat dataKey dengan warna
  const colorPalette = ["#8884d8", "#82ca9d", "#ffc658", "#ff7f50", "#a0522d"];
  const dataKey = employeeNames.map((name, index) => ({
    key: name,
    color: colorPalette[index % colorPalette.length]
  }));

  return {
    data: chartData,
    dataKey
  };
}